import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, inject } from "vue";
import { useSurveyStore } from "@/stores/surveyStore";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import QRCode from "@/components/shared/QRCode.vue";
import { PROVIDE_KEY_SHOW_TOAST_MESSAGE, ShowToastMessage } from "@/types";


const __default__ = {
  name: "MobileId",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const surveyStore = useSurveyStore();

const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const isEvaluable = ref(false);
// const shouldShowServiceEvaluation = ref(false);
// const toggleShowServiceEvaluation = (show: boolean) => {
//   shouldShowServiceEvaluation.value = show;
// };

const isScrolling = ref(false);
const onScroll = (event: Event) => {
  const element = event.target as HTMLElement;
  isScrolling.value = element.scrollTop > 0;
};

// const getServiceEvaluationContents = async () => {
//   const lineSurveyResult = await surveyStore.getServiceEvaluationContents();
//   const surveyId = lineSurveyResult.data?.id;
//   if (!lineSurveyResult.isSuccess || !surveyId) {
//     showToastMessage("서비스평가 정보가 없습니다");
//     isEvaluable.value = false;
//     return;
//   }
//   isEvaluable.value = true;
// };

// onMounted(() => {
//   getServiceEvaluationContents();
// });

const __returned__ = { surveyStore, showToastMessage, isEvaluable, isScrolling, onScroll, Page, NavigationBar, QRCode }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})